<template>
    <div class="top-head">
        <!-- 标题 -->
        <div class="top-head-left">
            <img :src="protectEasyLogo" style="width: 44%;margin-left: -38px;">
        </div>
        <!-- 右侧 -->
        <div class="top-head-right">
            <div>
                <Select v-model="language" style="color: #fff;" :transfer="true" @on-change="changeLanguage(language)" :placeholder="$t('message.switchLanguage')">
                    <Option v-for="item in languageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <span> |</span>
            </div>
            <div>{{ $t('message.hello') }},{{currentName}} !<span> |</span></div>
            <div>{{realTime}}<span> |</span></div>
          <div>
            <Select v-model="systemType" style="color: #fff;" :transfer="true" @on-change="changeSystem" :placeholder="$t('message.switchSystem')">
              <Option v-for="item in systemList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <span> |</span>
          </div>
            <div @click="logout" style="cursor: pointer;">{{ $t('message.logout') }}<span></span></div>
        </div>
    </div>
</template>
<script>
    import {setCookie, getCookie, delCookie} from '../utils/cookieUtil.js'

    var topHead = {}
    export default {
        name: 'TopHead',
        inject: ['reload'],
        data() {
            return {
                ourCompanyId: getCookie(global.companyId),
                languageList: [
                {
                    value: 'zh',
                    label: '中文'
                },
                {
                    value: 'en',
                    label: 'English'
                }],
                language: '',
                systemType: '',
                currentName: '',
                realTime: '',
                protectEasyLogo: require('../../static/images/silverLining.png'),
                systemList: [{
                  value: 1,
                  label: this.$t('message.managementSystem')
                }, {
                  value: 2,
                  label: 'Cloud Billing'
                }]

            }
        },
        mounted: function () {
            this.init()
            // 页面加载完后显示当前时间
            this.realTime = this.dealWithTime(new Date())
            // 定时刷新时间
            let _this = this
            // 定时器
            this.timer = setInterval(function () {
                _this.realTime = _this.dealWithTime(new Date()) // 修改数据date
            }, 1000)
        },
        beforeCreate: function () {
            topHead = this
        },
        methods: {
            //localStorage 存储数组对象的方法
            saveObjArr: function (name, data) {
                localStorage.setItem(name, JSON.stringify(data))
            },
            // 中英文切换
            changeLanguage(language) {
                if (this.language == "zh") {
                    localStorage.setItem('locale', 'zh');
                    this.$i18n.locale = localStorage.getItem('locale'); //关键语句
                    this.$Message.success('切换为中文!');
                } else if (this.language == "en") {
                    localStorage.setItem('locale', 'en')
                    this.$i18n.locale = localStorage.getItem('locale'); //关键语句
                    this.$Message.success('Switch to English!');
                }
                this.switchLanguage();
                this.reload();
            },

            switchLanguage: function () {
                var userDTO = {
                    'language': this.language == "zh" ? 0 : 1
                };

                this.$api.user.changeLanguage(userDTO)
                .then(res => {
                    // todo 后期待优化
                    window.localStorage.removeItem('router');
                    this.$api.security.userMenu("userName", getCookie(global.cookieName))
                    .then(res => {
                        this.getRouter = res.data;
                        this.saveObjArr('router', this.getRouter) //存储路由到localStorage
                        window.location.reload();
                        if (this.getRouter[0].type == undefined) {
                            this.$router.replace(this.getRouter[0].path);
                        } else {
                            this.$router.replace(this.getRouter[0].children[0].path);
                        }
                    });
                })
            },

            init: function (userName) {
                var isCookie = document.cookie.indexOf(global.cookieName)
                if (isCookie != -1 && userName != undefined && getCookie(global.cookieName) != '') {
                    // cookie不为空，并且是从登录那里来的时候
                    topHead.currentName = userName
                } else if (getCookie(global.cookieName) != '') {
                    // cookie不为空的时候，并且是原地刷新的时候(这里，直接改数据没办法改变的，因为用户是不可能直接改数据库的)
                    topHead.currentName = getCookie(global.cookieName)
                }
            },
            // 登出用户
            logout: function () {
                var userName = getCookie(global.cookieName)
                this.$api.user.logout('username', this.currentName)
                .then(res => {
                    delCookie(global.cookieName)
                    delCookie(global.companyId)
                    delCookie('admin')
                    delCookie('Authorization')
                    //删除动态路由
                    localStorage.removeItem('router');
                    //删除权限数组
                    localStorage.removeItem('permissionsList');
                    localStorage.clear();
                    // 如果是冠闵点击退出后 跳转到sso登录页
                    if(this.ourCompanyId==1){
                        // window.location.href = `${global.SSO_PORTAL}/sso/index.html#/login`
                      window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
                    }else{
                        window.location.reload();
                    }
                })
            },
            //切换系统
            changeSystem: function () {
                if (this.systemType === 1) {
                  this.$api.user.canChangeSystem({ destination: 'cmc' }).then(res => {
                    if (res.data.canChange === 1) {
                      delCookie(global.cookieName)
                      delCookie('admin')
                      //删除动态路由
                      localStorage.removeItem('router');
                      //删除权限数组
                      localStorage.removeItem('permissionsList');
                      // localStorage.clear();
                      const companyId = localStorage.getItem('companyId')
                      if (companyId === '1') {
                        window.location.href = `${process.env.SSO_PORTAL}/cmc/#/home/companyManage`
                      } else {
                        window.location.href = `${process.env.SSO_PORTAL}/cmc/#/home/userManage`
                      }
                    } else {
                      this.$Message.error(this.$t('message.noPermission'))
                    }
                  })
                } else {
                  this.$api.user.canChangeSystem({ destination: 'cfm' }).then(res => {
                    if (res.data.canChange === 1) {
                      const data = {
                        companyId: res.data.companyId,
                        token: res.data.token,
                        userId: res.data.userId,
                        name: res.data.userName,
                        locale: localStorage.getItem('locale')
                      }
                      window.location.href = `${process.env.CFM_PORTAL}/cfm/#/loading?companyId=${data.companyId}&userId=${data.userId}&token=${data.token}&name=${data.name}&locale=${data.locale}`
                    } else {
                      this.$Message.error(this.$t('message.noPermission'))
                    }
                  })
                }
            },
            // 实时显示当前时间
            dealWithTime: function (data) {
                let formatDateTime
                let Y = data.getFullYear()
                let M = data.getMonth() + 1
                let D = data.getDate()
                let H = data.getHours()
                let Min = data.getMinutes()
                let S = data.getSeconds()
                let W = data.getDay()
                H = H < 10 ? ('0' + H) : H
                Min = Min < 10 ? ('0' + Min) : Min
                S = S < 10 ? ('0' + S) : S
                switch (W) {
                case 0:
                W = '天'
                break
                case 1:
                W = '一'
                break
                case 2:
                W = '二'
                break
                case 3:
                W = '三'
                break
                case 4:
                W = '四'
                break
                case 5:
                W = '五'
                break
                case 6:
                W = '六'
                break
                default:
                break
                }

                formatDateTime = Y + '-' + M + '-' + D + ' ' + H + ':' + Min + ':' + S
                return formatDateTime
            },
            destroyed: function () {
                if (this.timer) {
                    clearInterval(this.timer)
                }
            }
        }
    }
</script>
<style scoped>
    .top-head {
        position: fixed;
        left: 0px;
        top: 0px;
        right: 0;
        height: 64px;
        background-color: #2b3245;
        overflow: hidden;
    }
    .top-head-left {
        float: left;
        font-size: 18px;
        color: #fff;
        text-align: center;
        width: 159px;
        line-height: 49px;
    }
    .top-head-right {
        min-width: 261px;
        float: right;
        color: #fff;
        line-height: 60px;
    }
    .top-head-right > div {
        float: left;
    }
    .top-head-right span {
        margin-right: 10px;
        margin-left: 5px;
    }
    .top-head-right >>> .ivu-select-selection {
        background: transparent;
        border: 0;
        box-shadow: none;
    }
    .top-head-right >>> .ivu-select-selected-value {
        color: #fff;
    }
    .top-head-right >>> .ivu-select-arrow {
        position: absolute;
        top: 50%;
        right: 8px;
        line-height: 1;
        transform: translateY(-50%);
        font-size: 14px;
        color: #808695;
        transition: all .2s ease-in-out;
    }
    .top-head-right >>> .ivu-select-placeholder {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/TopHead.vue